module.exports = __webpack_public_path__ + "d7b2ea59d782e8a05b9ac7df0eace1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-ojigi.png
// module id = 2038
// module chunks = 4